'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'child-combatant';
var width = 576;
var height = 512;
var aliases = ["child-rifle"];
var unicode = 'e4e0';
var svgPathData = 'M144 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 112 64a64 64 0 1 0 128 0zM480 336l0-10.7 52.2-17.4 .9-.3c6.5-2.2 10.9-8.3 10.9-15.2l0-12.5 0-72c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48 0 24-32 8 0-8 0-24 0-1 0-47 0-48c0-17.7-14.3-32-32-32l0-32 0-64 0-16c0-8.8-7.2-16-16-16L416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 32 0 32 0 32c-17.7 0-32 14.3-32 32l0 34.7c-18.6 6.6-32 24.4-32 45.3l0 112c0 19.9 12.1 36.9 29.3 44.2c.9 .4 1.8 .7 2.7 1l0 82.7 0 16c0 8.8 7.2 16 16 16l16 0 60.1 0 19.9 0c4.9 0 9.4-2.2 12.5-6s4.2-8.7 3.1-13.5l-4.3-19.5L498.2 432l-7.1-32 32.8 0 4.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-36.9 0-7.1 0L480 350.2l0-14.2zm-27.3 38.9l5.6 25.1 1.5 6.9 9.1 41.1 7.1 32L448 480l-4.7 0L416 480l0-32 0-50.7 0-13.3c0-4.2-1.6-8-4.3-10.9c-2.9-3.2-7.1-5.1-11.7-5.1c-6.4 0-12-3.8-14.5-9.3c-.7-1.6-1.2-3.3-1.4-5.1c-.1-.5-.1-1-.1-1.6l0-112c0-2.4 .5-4.7 1.5-6.7c2.5-5.5 8.1-9.3 14.5-9.3c4.6 0 8.8-2 11.7-5.1c2.6-2.9 4.3-6.7 4.3-10.9l0-13.3 0-2.7 0-32 32 0 0 32 0 16 0 48 0 32 0 8 0 6.3 0 23.1 0 3.7 0 7 0 14.2 0 1.8c0 1.2 .1 2.3 .4 3.5c0 0 0 0 0 0l.4 1.7 2.4 10.8 1.5 6.9zM144 199.9c7.7-5.1 16.8-7.9 26.3-7.9l11.3 0c9.5 0 18.6 2.8 26.3 7.9l0 .1 0 152-64 0 0-152 0-.1zM144 384l64 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-252.7 42.4 69.1c4.6 7.5 14.5 9.9 22 5.3s9.9-14.5 5.3-22l-59.8-97.5c-14.5-23.7-40.4-38.2-68.2-38.2l-11.3 0c-27.8 0-53.7 14.5-68.2 38.2L42.4 295.6c-4.6 7.5-2.3 17.4 5.3 22s17.4 2.3 22-5.3L112 243.3 112 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChildCombatant = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;